import React, { createContext, useContext, useState, useEffect, useRef } from 'react';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [progress, setProgress] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [hasVisited, setHasVisited] = useState(false);
    const startTimeRef = useRef(Date.now());

    // Constants for pacing
    const MIN_LOADING_TIME = 2000; // 2 seconds minimum "presence"
    const TRANSITION_DURATION = 1000; // 1 second dissolve

    // This function will be called by children (like IPhone.jsx) when technical loading is done
    const markTechnicalLoadComplete = () => {
        const elapsedTime = Date.now() - startTimeRef.current;
        const remainingTime = Math.max(0, MIN_LOADING_TIME - elapsedTime);

        setTimeout(() => {
            setIsLoading(false);
            setTimeout(() => {
                setHasVisited(true);
            }, TRANSITION_DURATION);
        }, remainingTime);
    };

    const value = {
        progress,
        setProgress,
        isLoading,
        hasVisited,
        markTechnicalLoadComplete,
    };

    return (
        <LoadingContext.Provider value={value}>
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};
